<div [id]='NAV_SCROLL_ID' class='scrollable-nav-tab'>
  <ng-container [ngSwitch]='mode'>
    <ng-container *ngSwitchCase='"FLOAT_RIGHT"'>
      <div class='nav-tabs-container'>
        <ng-content select='[navTabs]'></ng-content>
      </div>

      <div *ngIf='showArrows' class='nav-arrows-container'>
        <div class='nav-arrow-left h2 m-0'>
          <pt-icon (click)='!disableLeftArrow ? scrollTab(navTabs, -STEP) : null; $event.stopPropagation()'
                   [key]='IconArrowLeft'
                   [ngClass]='[!disableLeftArrow ? "cursor-pointer" : "text-black-50"]'
          ></pt-icon>
        </div>

        <div class='nav-arrow-right h2 m-0'>
          <pt-icon (click)='!disableRightArrow ? scrollTab(navTabs, STEP) : null; $event.stopPropagation()'
                   [key]='IconArrowRight'
                   [ngClass]='[!disableRightArrow ? "cursor-pointer" : "text-black-50"]'
          ></pt-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase='"AROUND"'>
      <div *ngIf='showArrows' class='nav-arrows-container'>
        <div class='nav-arrow-left h2 m-0'>
          <pt-icon (click)='!disableLeftArrow ? scrollTab(navTabs, -STEP) : null; $event.stopPropagation()'
                   [key]='IconArrowLeft'
                   [ngClass]='[!disableLeftArrow ? "cursor-pointer" : "text-black-50"]'
          ></pt-icon>
        </div>
      </div>

      <div class='nav-tabs-container'>
        <ng-content select='[navTabs]'></ng-content>
      </div>

      <div *ngIf='showArrows' class='nav-arrows-container'>
        <div class='nav-arrow-right h2 m0'>
          <pt-icon (click)='!disableRightArrow ? scrollTab(navTabs, STEP) : null; $event.stopPropagation()'
                   [key]='IconArrowRight'
                   [ngClass]='[!disableRightArrow ? "cursor-pointer" : "text-black-50"]'
          ></pt-icon>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
